// @flow
import * as React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { LayoutActions } from 'material-ui-layout';
import classnames from 'classnames';
import map from 'lodash/map';

import useSiteInfo from '~hooks/useSiteInfo';
import FieldLink from '~plugins/prismic/components/FieldLink';

import DrawerItem from './DrawerItem';

import type { Props } from './types';
import styles from './styles';

const Drawer = ({
  closeDrawer,
  closeDrawerOnClick,
  position,
  className,
  classes,
  ...props
}: Props): React.Node => {
  const siteInfo = useSiteInfo();
  const layoutActions = React.useContext(LayoutActions);

  const handleDrawerClose =
    position === 'right'
      ? layoutActions.handleRightDrawerClose
      : layoutActions.handleLeftDrawerClose;

  const handleDrawerItemClick = React.useCallback(
    () => handleDrawerClose && setTimeout(handleDrawerClose, 10),
    [handleDrawerClose],
  );

  return (
    <div className={classnames(classes.root, className)} {...props}>
      <div className={classes.drawerHeading}>
        <IconButton
          disableRipple
          aria-label="Close Icon"
          onClick={handleDrawerClose}
          className={classes.icon}
        >
          <CloseIcon color="inherit" fontSize="large" />
        </IconButton>
      </div>
      {siteInfo?.data?.appbar_actions?.length ? (
        <div className={classes.menuLinks}>
          {map(siteInfo?.data?.appbar_actions, (item, index: number) =>
            item &&
            item.action_label &&
            item.action_label.text &&
            item.action_link ? (
              <DrawerItem
                key={index}
                component={FieldLink}
                field={item.action_link}
                label={item.action_label.text}
                onClick={handleDrawerItemClick}
              />
            ) : null,
          )}
        </div>
      ) : null}
    </div>
  );
};

Drawer.defaultProps = {
  className: undefined,
  closeDrawer: undefined,
  closeDrawerOnClick: undefined,
  position: undefined,
};

export default withStyles<*, *, Props>(styles)(Drawer);
